import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { PartnerType } from '@/types/api';

export const partnerTypeKeys = {
  all: ['partner-types'] as const,
  list: () => [...partnerTypeKeys.all, 'list'] as const,
  detail: (id: string) => [...partnerTypeKeys.all, 'detail', id] as const,
};

export function usePartnerTypes() {
  return useQuery({
    queryKey: partnerTypeKeys.list(),
    queryFn: () => api.get<PartnerType[]>('/api/v1/partner-types'),
  });
}

export function usePartnerType(id: string) {
  return useQuery({
    queryKey: partnerTypeKeys.detail(id),
    queryFn: () => api.get<PartnerType>(`/api/v1/partner-types/${id}`),
    enabled: !!id,
  });
}
